import * as React from "react";
import { Modal } from "./Modal.js";

interface Props { open: boolean; title: string; message: string; confirmLabel?: string; onConfirm: () => void; onCancel: () => void; destructive?: boolean; }

export function ConfirmDialog({ open, title, message, confirmLabel = "Confirm", onConfirm, onCancel, destructive }: Props) {
  return (
    <Modal open={open} onClose={onCancel} title={title}>
      <p className="text-sm text-body mb-4">{message}</p>
      <div className="flex gap-2 justify-end">
        <button onClick={onCancel} className="px-4 py-2.5 rounded-md bg-amethyst-soft text-amethyst-ink text-sm font-medium hover:bg-amethyst-soft/70 transition-colors">Cancel</button>
        <button onClick={onConfirm} className={`px-4 py-2.5 rounded-md text-sm font-medium transition-colors ${destructive ? "bg-error-wash text-error-text hover:bg-error-wash/70" : "bg-primary text-white hover:bg-amethyst-ink"}`}>{confirmLabel}</button>
      </div>
    </Modal>
  );
}
